import { Button } from '@sgme/ui';
import classNames from 'classnames';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCopyTextToClipboard } from 'hooks/useCopyToClipboard';
import { selectEssentialsFormQuoteResult } from 'routes/essential-workspace/state/form.selectors';

export function QuoteId({
  isStrikethrough = false,
  formId,
  className,
}: {
  isStrikethrough?: boolean;
  formId: string;
  className?: string;
}) {
  const quoteExternalId = useAppSelector(state => selectEssentialsFormQuoteResult(state, formId)?.quoteExternalId);

  const copyExternalQuoteIdToClipboard = useCopyTextToClipboard(
    'moreMenu.copyToClipboard.externalQuoteId.success',
    'moreMenu.copyToClipboard.externalQuoteId.error',
  );

  if (!quoteExternalId) {
    return null;
  }

  return (
    <div className="flex-x gap-2">
      <span className={classNames('fw-medium', { 'text-decoration-line-through': isStrikethrough }, className)}>
        {quoteExternalId}
      </span>
      <Button
        iconPosition="icon-only"
        size="sm"
        className={className}
        purpose="link"
        onClick={() => copyExternalQuoteIdToClipboard(quoteExternalId)}
      >
        <i className="icon icon-sm lh-1 fw-medium">content_copy</i>
      </Button>
    </div>
  );
}
